// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   // Check isLoggedIn directly from localStorage on render
//   const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

//   // Log for debugging
//   console.log("PrivateRoute - isLoggedIn:", isLoggedIn);

//   return isLoggedIn ? children : <Navigate to="/" />;
// };

// // export default PrivateRoute;

import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
  // Check login status and role from localStorage
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const userRole = localStorage.getItem("role");

  // Log for debugging
  console.log("PrivateRoute - isLoggedIn:", isLoggedIn, "userRole:", userRole, "allowedRoles:", allowedRoles);

  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    console.log("User not logged in, redirecting to /");
    return <Navigate to="/" replace />;
  }

  // If role is not in allowedRoles, redirect to an unauthorized page or default dashboard
  if (!allowedRoles.includes(userRole)) {
    console.log("Role not authorized, redirecting to /unauthorized");
    return <Navigate to="/" replace />; // Or redirect to "/dashboard" for regular users
  }

  // If authorized, render the children (the protected component)
  return children;
};

export default PrivateRoute;